import { client } from '../http';

export default {
  async getFinancialProfileScore() {
    const response = await client.get('/api/financial-profile-score');
    return response.data;
  },
};
